import { render, staticRenderFns } from "./VgvField.vue?vue&type=template&id=071301c0&"
import script from "./VgvField.vue?vue&type=script&lang=js&"
export * from "./VgvField.vue?vue&type=script&lang=js&"
import style0 from "./VgvField.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/c6monbi/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('071301c0')) {
      api.createRecord('071301c0', component.options)
    } else {
      api.reload('071301c0', component.options)
    }
    module.hot.accept("./VgvField.vue?vue&type=template&id=071301c0&", function () {
      api.rerender('071301c0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/components/vgv/VgvField.vue"
export default component.exports